import { render, staticRenderFns } from "./SubscriptionWaiting.vue?vue&type=template&id=577df4b4"
import script from "./SubscriptionWaiting.vue?vue&type=script&lang=js"
export * from "./SubscriptionWaiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports